import { jsx as _jsx } from "react/jsx-runtime";
import { TextM } from '../../../../../infra/dls/components/typography';
export var TwoFaErrorMessage = function (_a) {
    var errorMessage = _a.errorMessage, className = _a.className;
    if (!errorMessage) {
        return null;
    }
    return (_jsx(TextM, { color: "negative", className: className, children: errorMessage }));
};
